import { useLocation, useParams } from 'quartz-routing/react-router';
import { useEffect } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { ButtonGroup } from 'foundations-components/transitional/components/ButtonGroup';
import { ACRedirect } from 'academy-common-lib/components/ACRedirect';
import { ACRouterButton } from 'academy-common-lib/components/ACRouterButton';
import ErrorBoundary from '../../../components/Errors/ErrorBoundary';
import UsageTracker from '../../../utils/UsageTracker';
import Card from '../components/common/Card';
import PlaylistsTable from '../components/playlists/PlaylistsTable';
import PlaylistsTableFilters from '../components/playlists/PlaylistsTableFilters';
import { PAGE_NAMES } from '../../../constants/Navigation.legacy';
import { FiltersCard } from 'academy-common-lib/features/filters/components/FiltersCard';
import { PageHeader } from 'academy-common-lib/features/header/components/PageHeader';
import { getBreadcrumbItem } from '../constants/breadcrumbs';
import { ALL_PLAYLISTS_PATH, COMPLETED_PLAYLISTS_PATH, INCOMPLETE_PLAYLISTS_PATH } from '../constants/routes';
import { removePageParam } from '../utils/paginationUtils';
import { getStatus } from '../utils/playlistsUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const tableNames = {
  INCOMPLETE: 'playlistsIncomplete',
  COMPLETED: 'playlistsCompleted'
};
export const RedirectToPlaylistsDefaultTab = () => {
  const location = useLocation();
  return /*#__PURE__*/_jsx(ACRedirect, {
    to: Object.assign({}, location, {
      pathname: ALL_PLAYLISTS_PATH
    })
  });
};
const MyTeamPlaylists = () => {
  const {
    playlistStatus
  } = useParams();
  const status = getStatus(playlistStatus);
  const location = useLocation();
  const tableName = status ? tableNames[status] : 'playlistsAll';
  const breadcrumbs = [getBreadcrumbItem({
    pageKey: 'MY_TEAM'
  }), getBreadcrumbItem({
    pageKey: 'MY_TEAM_PLAYLISTS',
    isCurrent: true
  })];
  useEffect(() => {
    UsageTracker.track('pageView', {
      screen: PAGE_NAMES.MY_TEAM_PLAYLISTS
    });
  }, []);
  return /*#__PURE__*/_jsxs(View, {
    children: [/*#__PURE__*/_jsx(PageHeader, {
      breadcrumbs: breadcrumbs,
      subtitle: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.heading.headingSubTitles.MY_TEAM_PLAYLISTS"
      }),
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.heading.headingTitles.MY_TEAM_PLAYLISTS"
      })
    }), /*#__PURE__*/_jsx(FiltersCard, {
      paddingBlock: "400",
      paddingInline: "400",
      shouldRenderClearFilters: false,
      children: /*#__PURE__*/_jsxs(ButtonGroup, {
        children: [/*#__PURE__*/_jsx(ACRouterButton, {
          active: status === undefined,
          replace: true,
          to: {
            pathname: ALL_PLAYLISTS_PATH,
            search: removePageParam(location.search)
          },
          use: "tertiary-extra-light",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.myTeam.playlists.tabs.all"
          })
        }), /*#__PURE__*/_jsx(ACRouterButton, {
          active: status === 'COMPLETED',
          replace: true,
          to: {
            pathname: COMPLETED_PLAYLISTS_PATH,
            search: removePageParam(location.search)
          },
          use: "tertiary-extra-light",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.myTeam.playlists.tabs.completed"
          })
        }), /*#__PURE__*/_jsx(ACRouterButton, {
          active: status === 'INCOMPLETE',
          replace: true,
          to: {
            pathname: INCOMPLETE_PLAYLISTS_PATH,
            search: removePageParam(location.search)
          },
          use: "tertiary-extra-light",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.myTeam.playlists.tabs.incomplete"
          })
        })]
      })
    }), /*#__PURE__*/_jsxs(Card, {
      children: [/*#__PURE__*/_jsx(PlaylistsTableFilters, {
        tableName: tableName
      }), /*#__PURE__*/_jsx(ErrorBoundary, {
        boundaryName: "PlaylistsTable",
        children: /*#__PURE__*/_jsx(PlaylistsTable, {
          tableName: tableName
        })
      })]
    }, tableName)]
  });
};
export default MyTeamPlaylists;